import { memo, useMemo } from "react";

import { type HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { useStartGuideHighlightStep1 } from "./hooks/use-start-guide-highlight-step1";
import { NavigateSelectHotelTemplatePage } from "./navigate-select-hotel-template-page";
import { ResetHotelTemplateType } from "./reset-hotel-template-type";
import { Step1 } from "./step-1";
import { Step2 } from "./step-2";
import { Step3 } from "./step-3";
import { Step4 } from "./step-4";
import { Step5 } from "./step-5";
import { Step6 } from "./step-6";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	hotelTemplateSettings: HotelTopQuery["hotelTemplateSettings"];
	hotelUrls: HotelTopQuery["hotelUrls"];
	hotelID: string;
	isTestReservationAvailable: boolean;
};

export const TodoListContent = memo(
	({ startGuide, hotelTemplateSettings, hotelUrls, hotelID, isTestReservationAvailable }: Props) => {
		const step2Disabled = useMemo(() => {
			return !startGuide.isHotelInfoRegistered || !startGuide.isHotelPolicyRegistered;
		}, [startGuide.isHotelInfoRegistered, startGuide.isHotelPolicyRegistered]);

		// ステップ1のハイライト実行
		useStartGuideHighlightStep1(startGuide);

		return (
			<div className="space-y-12">
				<Step1 startGuide={startGuide} />
				<Step2 startGuide={startGuide} disabled={step2Disabled} />
				<Step3 startGuide={startGuide} hotelTemplateSettings={hotelTemplateSettings} disabled={step2Disabled} />
				<Step4 startGuide={startGuide} disabled={step2Disabled} />
				<Step5 startGuide={startGuide} disabled={step2Disabled} />
				<Step6
					hotelUrls={hotelUrls}
					hotelID={hotelID}
					isTestReservationAvailable={isTestReservationAvailable}
					disabled={step2Disabled}
				/>
				<ResetHotelTemplateType hotelTemplateSettings={hotelTemplateSettings} />
				<NavigateSelectHotelTemplatePage hotelTemplateSettings={hotelTemplateSettings} />
			</div>
		);
	},
);

TodoListContent.displayName = "TodoListContent";
